import {
  FieldsetProps as MantineFieldsetProps,
  Fieldset as MantineFieldset,
} from '@mantine/core';

export type FieldsetProps = MantineFieldsetProps;

export const Fieldset = MantineFieldset;

Fieldset.displayName = 'Fieldset';
